import { render, staticRenderFns } from "./SubirImagen.vue?vue&type=template&id=1bdd596d&"
import script from "./SubirImagen.vue?vue&type=script&lang=ts&"
export * from "./SubirImagen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports